import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchTaskOrderDetails } from '../../actions/additional_actions';
import { getDateValue } from '../../utils/date';
import { formatMoney } from '../../utils/budget';
import {INITIATE_STO_URL} from '../../actions/index'; 

class TaskOrderDetail extends Component {
    // static PropTypes = {
    //     taskorders: PropTypes.array.isRequired,
    // }

    constructor(props) {
        super(props);

        this.state = {
            contract: {},
            currentPage: 1,
            itemsPerPage: 5
        }
        this.handleClick = this.handleClick.bind(this);
        this.changeNumItemsShown = this.changeNumItemsShown.bind(this);
        this.initiateSto = this.initiateSto.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { contract } = this.props;
        this.props.fetchTaskOrderDetails(contract.projectId, contract.contractId);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.contract.contractId !== this.props.contract.contractId) {
            this.props.fetchTaskOrderDetails(this.props.contract.projectId, this.props.contract.contractId);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.taskorders !== nextProps.taskorders)
            this.setState({ taskorders: nextProps.taskorders })
        if (this.props.contract.contractId !== nextProps.contract.contractId)
            this.setState({ contract: nextProps.contract })
    }

    handleClick(event) {
        this.setState({
            currentPage: Number(event.target.id)
        });
    }

    changeNumItemsShown(e) {
        if (e.target.value < 2 || e.target.value > this.props.taskorders.length) {
            // || ((e.target.value > this.props.blueBooks.length/2) && (this.state.currentPage)) )
            // console.log(this.state.currentPage);
        }
        else {
            this.setState({ itemsPerPage: e.target.value });
            //   console.log(this.state.currentPage);
        }
    }

    initiateSto(toid) {
        const projectId = this.props.contract.projectId;
        let url = INITIATE_STO_URL + toid + '/' + projectId;
        window.open(url,'_blank');
    }

    render() {
        const { currentPage, itemsPerPage } = this.state;

        // Logic for displaying items
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentTO = this.props.taskorders.slice(indexOfFirstItem, indexOfLastItem);

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(this.props.taskorders.length / itemsPerPage); i++) {
            pageNumbers.push(i);
        }
        return (
            <div id="changeorders">
                {this.props.taskorders.length > 0 ?
                    <div id="accordiondetails" className="row-wide">
                        <div className="col s12">
                            <div className="dw-table">
                                <table className="table-striped">
                                    <thead>
                                        <tr>
                                            <th>TO #</th>
                                            <th>Status</th>
                                            <th>Description</th>
                                            <th>Registration Amount</th>
                                            <th>Estimated Amount</th>
                                            <th>Start Date</th>
                                            <th>TO End Date</th>
                                            <th>Type</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {currentTO.map((co, index) => {
                                            return <tr key={index} >
                                            {co.toType==='TASK ORDER ' ?   <td>{co.toNo}</td> :   <td>{co.stoNo}</td> }                                              
                                                <td>{co.toStatus}</td>
                                                <td>{co.toDesc}</td>
                                                <td>{formatMoney(co.toRegAmt)}</td>
                                                <td>{formatMoney(co.toEstAmt)}</td>
                                                <td>{getDateValue(co.toStrtDt)}</td>
                                                <td>{getDateValue(co.toCurEndDate)}</td>
                                                <td>{co.toType}</td>
                                                <td>{co.toType === 'TASK ORDER ' 
                                                    ? <button className="btn-save color-save-override" onClick={() => this.initiateSto(co.toid)}>Initiate STO</button>
                                                    : null}</td>
                                            </tr>
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {pageNumbers.length > 1 &&
                            <div>
                                <div className="col s12">
                                    <div className="controls margin-top-1">
                                        <label className="label-pagination">Show</label>
                                        <input type="number" value={itemsPerPage} onChange={this.changeNumItemsShown}
                                            min="2" max={this.props.taskorders.length - 1} className="input-pagination" />
                                        <span className="label-pagination">Records</span>
                                    </div>
                                </div>

                                <div className="col s12">
                                    <div className="pagination-blue-book">
                                        <ul id="page-numbers">
                                            {pageNumbers.map(number => {
                                                return <li
                                                    key={number}
                                                    id={number}
                                                    onClick={this.handleClick}
                                                    className={currentPage === number ? 'active' : ''}
                                                >
                                                    {number}
                                                </li>
                                            })}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        } </div> :
                    <div className="noData">
                        No Task Orders are found for this contract.
            </div>}
            </div>
        );
    }
}

TaskOrderDetail.propTypes = {
    taskorders: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        taskorders: state.additionalProjectsStore.toDetail,
        projectId: ownProps.projectId
    };
}

export default connect(mapStateToProps, { fetchTaskOrderDetails })(TaskOrderDetail);